import { render } from "./CadastroUsuariosView.vue?vue&type=template&id=3a09023c"
import script from "./CadastroUsuariosView.vue?vue&type=script&lang=js"
export * from "./CadastroUsuariosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__